"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandConfig = void 0;
var monarch_bg_svg_1 = __importDefault(require("../assets/backgrounds/monarch-bg.svg"));
var calvert_bg_svg_1 = __importDefault(require("../assets/backgrounds/calvert-bg.svg"));
var monarch_logo_svg_1 = __importDefault(require("../assets/logos/monarch-logo.svg"));
var calvert_logo_svg_1 = __importDefault(require("../assets/logos/calvert-logo.svg"));
var monarch_ico_1 = __importDefault(require("../assets/favicons/monarch.ico"));
var calvert_ico_1 = __importDefault(require("../assets/favicons/calvert.ico"));
var brand_enum_1 = require("./../shared/enums/brand.enum");
var themes_1 = require("../themes");
var subject_config_1 = require("./subject.config");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.brandConfig = (_a = {},
    _a[brand_enum_1.BrandEnum.MONARCH] = {
        name: 'Monarch',
        logo: monarch_logo_svg_1.default,
        background: monarch_bg_svg_1.default,
        theme: themes_1.monarchTheme,
        favicon: monarch_ico_1.default,
        subject: subject_config_1.subjectConfig.MONARCH,
    },
    _a[brand_enum_1.BrandEnum.CALVERT] = {
        name: 'Calvert',
        logo: calvert_logo_svg_1.default,
        background: calvert_bg_svg_1.default,
        theme: themes_1.calvertTheme,
        favicon: calvert_ico_1.default,
        subject: subject_config_1.subjectConfig.CALVERT,
    },
    _a);
